<div [formGroup]="form" class="step-form">

  <!-- ── Action type ── -->
  <div class="section-label">
    <mat-icon class="section-icon">cleaning_services</mat-icon>
    <span>{{ stepLabel }} — choose an action</span>
  </div>

  <div class="action-tile-row">
    <div
      *ngFor="let tile of actionTiles"
      class="action-tile"
      [class.action-tile--selected]="selectedAction === tile.value"
      (click)="selectAction(tile.value)"
      (keyup.enter)="selectAction(tile.value)"
      tabindex="0"
      role="button"
      [attr.aria-pressed]="selectedAction === tile.value"
      [attr.aria-label]="tile.label">
      <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
      <div class="tile-content">
        <strong>{{ tile.label }}</strong>
        <p class="tile-desc">{{ tile.description }}</p>
      </div>
    </div>
  </div>

</div>
